import { render, staticRenderFns } from "./MamTradeHistoryScreen.vue?vue&type=template&id=45aa6808&scoped=true"
import script from "./MamTradeHistoryScreen.vue?vue&type=script&lang=js"
export * from "./MamTradeHistoryScreen.vue?vue&type=script&lang=js"
import style0 from "./MamTradeHistoryScreen.vue?vue&type=style&index=0&id=45aa6808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa6808",
  null
  
)

export default component.exports